<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="套餐名称：">
                <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" clearable></el-input>
            </el-form-item>
             <el-form-item label="跨月类型："> 
                <el-select v-model="searchForm.isNextMonth" clearable>
                    <el-option label="跨月" value="1"></el-option>
                    <el-option label="自然月" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getPkgGroupListPageHandle">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"  >
            <el-table-column prop="name" label="系列名称" align="center" show-overflow-tooltip></el-table-column> 
            <el-table-column prop="isNextMonthName" label="跨月类型" align="center" show-overflow-tooltip></el-table-column>  
            <el-table-column prop="stateName" label="状态" align="center" show-overflow-tooltip></el-table-column> 
                 <el-table-column prop="miaoPrice" label="套餐返佣/元" align="center" show-overflow-tooltip></el-table-column> 
               <el-table-column prop="createTime" label="创建时间" width="140" align="center" show-overflow-tooltip></el-table-column> 
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
                <el-form-item label="套餐组名称：" prop="name">
                    <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
                </el-form-item>    
                <el-form-item label="余额限制：" prop="type">
                      <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
                        <el-option v-for="item in isPriceOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item> 
                  <el-form-item label="余额购买参数：" prop="priceData">
                    <el-input v-model.trim="addOrEditGroupForm.priceData" placeholder="严谨按照参数规范填写 参数示列请点击下方按钮" clearable></el-input>
                </el-form-item>   
                <el-form-item label="是否跨月：" prop="isNextMonth">
                      <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
                        <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>  
                 <el-form-item label="活动类型：" prop="isPrice">
                      <el-select v-model="addOrEditGroupForm.isSale" placeholder="请选择">
                        <el-option v-for="item in isPriceOptions" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>  
                <el-form-item label="秒反设置：" prop="isMiao">
                      <el-select v-model="addOrEditGroupForm.isMiao" placeholder="请选择">
                        <el-option v-for="item in isMiaoList" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>  
            <el-form-item v-show="addOrEditGroupForm.isMiao==1" label="秒反金额/元：" prop="miaoPrice">
                    <el-input v-model.trim="addOrEditGroupForm.miaoPrice" placeholder="请输入你要秒反得金额" clearable></el-input>
                </el-form-item> 
                       <el-form-item label="套餐类型：" prop="isNextMonth">
                      <el-select v-model="addOrEditGroupForm.isVoice" placeholder="请选择">
                        <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>   


                <el-form-item label="实名跳转：" prop="poolName">
                    <el-input v-model.trim="addOrEditGroupForm.poolName" placeholder="控制实名跳转，电信卡请填 电信 ，联通卡 填联通。特殊实名链接 请直接填链接" clearable></el-input>
                </el-form-item>   
                 <el-form-item label="微信弹窗内容：" prop="remark">
                    <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="将会在微信套餐页面进行弹窗提示" clearable></el-input>
                </el-form-item>     
                           <el-form-item label="自动续费：" prop="">
                    <el-radio-group v-model="addOrEditGroupForm.isDown">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>  


                <el-form-item label="实名限制：" prop="isAuth">
                    <el-radio-group v-model="addOrEditGroupForm.isAuth">
                        <el-radio :label="1">无限制</el-radio>
                        <el-radio :label="0">先套餐后实名</el-radio>
                    </el-radio-group>
                </el-form-item>  
          
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="showYue">查询余额参数示列</el-button>
                <el-button @click="cancel">取 消</el-button>
                <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
            </div>            
        </el-dialog>  

           <el-dialog :append-to-body="true"  title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1" :close-on-click-modal="false">
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：最多只支持6个参数，amount代表充值金额/元 giftBalance表示赠送金额/元。请修改后完整输入此参数</div>
            <div style="text-align: center; width:100%;">               
                <p  alt="" style="margin: 0 auto;">{{urls}}</p>  
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
            </div>            
        </el-dialog>
    </div>
</template>
<script>
import {getPkgGroupListPages,addPkgGroup,updatePkgGroup,changePkgGroupState, getPkgIsMonthOption} from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data(){
        return {
            urls:'',
            shareImgs:false,
            searchForm: {
                name: '',
                isVoice:'',
                isNextMonth:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,                
            },      
            isPriceOptions:[
                 
                {
                    code:0,
                    description:'无活动'
                },
                 {
                    code:1,
                    description:'60元预存活动'
                }
            ], 
        isMiaoList:[
                 
                {
                    code:0,
                    description:'不秒反'
                },
                 {
                    code:1,
                    description:'一次性秒反'
                }
            ],      
            addOrEditGroupForm: {
                name: '',
                type: '',
                isMiao:'',
                miaoPrice:'',
                isSale:'',
                isAuth:'',
                isNextMonth: '',
                supplierType: '1',
                remark:'',
                isDown:'',
                priceData:'',
                poolName:'',
                isVoice:''
            },
             isPriceOption:[
                {
                    code:0,
                    description:'不限制'
                },
                 {
                    code:1,
                    description:'限制余额'
                },
  {
                    code:2,
                    description:'限制余额并且开户预存'
                }
            ],
         isVoiceOption:[
                {
                    code:0,
                    description:'流量'
                },
                 {
                    code:1,
                    description:'流量+语音'
                }
            ],
            currentId: '',
            addFlag: null,
            addGroupVisibale: false,
            title: '',
            pkgTypeOption: [],
            supplierOption: [],
            isMonthOption: [],
            addOrEditGroupRules: {
                name: [{required: true, message: '请输入套餐名称', trigger: 'blur'}],
                type: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                isNextMonth: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                supplierType: [{required: true, message: '请选择套餐名称', trigger: 'change'}]
            }
        }
    },
    methods: {
          //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
              this.shareImgs=false;
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        showYue(){
            this.urls='[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]'
            this.shareImgs=true;
        },
        cancel(){
            this.shareImgs=false;
            this.addGroupVisibale = false;      
            this.$refs.addOrEditGroupForm.resetFields();    
        }, 
        cancel1(){
            this.shareImgs=false;
        },   
        showbtnText(state){
            return common.showTxtByState(state, {0: '启用', 1: '禁用'})
        },
        getPkgGroupListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getPkgGroupListPages(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            }) 
        },
        showAddPkgGroup(){
            this.addGroupVisibale = true;
            this.addFlag = true;
            this.title = "新增套餐组";             
            this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
        },
        showEditPkgGroup(row){
            this.addGroupVisibale = true;
            this.addFlag = false;
            this.title = "修改套餐组";
            this.addOrEditGroupForm.isAuth=row.isAuth;
            this.addOrEditGroupForm.name = row.name;
            this.addOrEditGroupForm.type = row.type;
            this.addOrEditGroupForm.isVoice=row.isVoice;
               this.addOrEditGroupForm.isSale=row.isSale;
            this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
            this.addOrEditGroupForm.supplierType = row.supplierType;
            this.addOrEditGroupForm.remark = row.remark;
            this.addOrEditGroupForm.poolName=row.poolName;
            this.addOrEditGroupForm.priceData=row.priceData;
            this.currentId = row.id; 
            this.addOrEditGroupForm.isDown=row.isDown;
               this.addOrEditGroupForm.isMiao=row.isMiao;
                  this.addOrEditGroupForm.miaoPrice=row.miaoPrice;
        },
        addOrEidtGroupHandle(){
            this.$refs.addOrEditGroupForm.validate(valid => {
                if(valid) {
                    var data = this.addOrEditGroupForm;
                    if(this.addFlag == true){
                        addPkgGroup(data).then(res => callback(res))
                    }else{
                        data.id = this.currentId
                        updatePkgGroup(data).then(res => callback(res))               
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgGroupListPageHandle();
                        _this.addGroupVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            }) 
        },
        changeStateHandle(id){
            var data = {
                id
            }
            changePkgGroupState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getPkgGroupListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })           
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgGroupListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getPkgGroupListPageHandle();
        }  
    },
    created () {
        this.getPkgGroupListPageHandle();
        common.getPkgTypeOptionCom(this, 'pkgTypeOption');
        common.getSupplierOptionCom(this, 'supplierOption');
        getPkgIsMonthOption().then(res => {
            if(res.data.code == 200){
                this.isMonthOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }            
        })
    }    
}
</script>
<style>

</style>
